import { FilterValue } from "../Filters/FilterValue";

export const ProjectRequestStatus: FilterValue[] = [
  { id: "1", value: "OPEN" },
  { id: "2", value: "APPROVED" },
  { id: "3", value: "CANCELLED" },
];
